import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <>
      {/* start - Footer*/}
      <footer className="" id="footer">
        <div className="container-fluid">
          <div className="">© 2025 جميع الحقوق محفوظة لوزارة الصحة و السكان المصرية - Ver 16.1</div>
          <div className="">
            <a href="http://www.dmsegypt.net" target="_blank" rel="noopener noreferrer">
              <img src="/assets/images/logo-dms.png" width="61" height="20" alt="DMS Egypt" />
            </a> Developed by
          </div>
          <div className="clearfix"></div>
        </div>
      </footer>
      <div className="load"></div>
      {/* End - Footer */}
    </>
  );
};

export default Footer;
